import { Component, OnInit, ViewChild } from '@angular/core';
import { LocalStorageService } from 'ngx-store';
import { MatTableDataSource, MatAutocompleteTrigger, MatAutocomplete } from '@angular/material';
import { MatSort } from '@angular/material/sort';
import { RemoteService } from 'app/services/remote.service';
import { NotifierService } from 'angular-notifier';
import { DatePipe } from '@angular/common';
import { Router } from '@angular/router';
import { Observable, fromEvent } from 'rxjs';
import { map, startWith, takeUntil } from 'rxjs/operators';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { TooltipPosition } from '@angular/material/tooltip';

@Component({
  selector: 'app-import-csv-file',
  templateUrl: './import-csv-file.component.html',
  styleUrls: ['./import-csv-file.component.scss']
})
export class ImportCsvFileComponent implements OnInit {

  @ViewChild('auto') statesAutocompleteRef1: MatAutocomplete;
  @ViewChild(MatAutocompleteTrigger) autocompleteTrigger1: MatAutocompleteTrigger;
  count1: number = 0;
  displayedColumns1: string[] = ['brokerCsvColumn', 'standardCsvColumn', 'status'];
  dataSource1 = new MatTableDataSource();
  @ViewChild('sort1') sort1: MatSort;
  displayedColumns: string[] = ['selectAll', 'holdingName', 'purchaseDate', 'tradeType', 'quantity', 'currentPrice', 'brokerage', 'exchangeRate', 'action', 'status'];
  dataSource = new MatTableDataSource();
  positionOptions: TooltipPosition[] = ['right', 'above'];
  position = new FormControl(this.positionOptions[0]);
  position1 = new FormControl(this.positionOptions[1]);
  filteredStocks: Observable<Stocks[]>;
  stocksDetails: Stocks[] = [];
  //@ts-ignore
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  csvFileData: any;
  disableButton: boolean = true;
  count: number;
  stockTradearray: any[];
  stockForTrade1: any;
  totalPurchasingValue: number = 0;
  selectedCount: number = 0;
  copyCsvData: any;
  editIndex: any;
  importCsv: FormGroup;
  importBrkerCsv: FormGroup;
  countStock: number;
  stockDetails: any;
  editTradeData: any;
  exchangePrice: number = 0;
  showexchangeLabel: boolean;
  showCurrentLabel: boolean;
  stockCurrency: any;
  formSumitAttempt: boolean;
  statusCount: number;
  showPrice: boolean;
  showExchangeRate: boolean;
  symbolAndExchange: any;
  addSingleTradeStatus: boolean;
  addSingleTradeIndex: any;
  selectedTrades: any[];
  globalIndex: number;
  arraindex: any[];
  failedArray: any[];
  showExchangeListSpinner1: boolean;
  isAutocomplete1: boolean;
  registerStocks = [];
  showMore: boolean = true;
  dupliCateBrokersColumns = [];
  brokersColumns = [];
  editBrokerIndex: any;
  constructor(public ls: LocalStorageService,
    private service: RemoteService,
    private notifierService: NotifierService,
    private datePipe: DatePipe,
    private fb: FormBuilder,
    private router: Router) { }

  ngOnInit() {
    this.dupliCateBrokersColumns = this.ls.get('csvColumns');
    this.dupliCateBrokersColumns.unshift({
      brokerCsvColumn: "none",
      standardCsvColumn: "none"
    })
    this.brokersColumns = this.ls.get('csvColumns');
    try {
      //@ts-ignore
      $('.datepicker').datepicker({ maxDate: new Date() });
      //@ts-ignore
      $("input[name$='group1']").click(function () {
        //@ts-ignore
        var test = $(this).val();
        //@ts-ignore
        $("div.radioblocksshwhide").hide();
        //@ts-ignore
        $("#radioblock" + test).show();
      });
    } catch (e) { }
    this.importBrkerCsv = this.fb.group({
      standardCsvColumn: [''],
    })
    this.importCsv = this.fb.group({
      name: [''],
      symbol: [''],
      exchange: [''],
      brokerage: [''],
      purchaseDate: [''],
      tradeType: [''],
      quantity: ['', [Validators.required, Validators.min(1)]],
      currentPrice: ['', [Validators.required, Validators.min(0.0001)]],
      exchangeRate: new FormControl(''),
      tradeCurrency: [''],
      brokerageCurrency: [''],
      holdingName: ['', Validators.required]
    })
    this.findDuplicateBrokerCsvColumns();
    this.dataSource1 = new MatTableDataSource(this.brokersColumns);
    this.dataSource1.sort = this.sort1;
    this.service.scrollingtoNavbar();
  }

  findDuplicateBrokerCsvColumns() {
    var names = [];
    this.brokersColumns.map(res => {
      res.isDuplicate = false;
      if (res.standardCsvColumn !== 'none') {
        names.push(res.standardCsvColumn)
      }
    })

    const count = names =>
      names.reduce((a, b) => ({
        ...a,
        [b]: (a[b] || 0) + 1
      }), {})

    const duplicates = dict =>
      Object.keys(dict).filter((a) => dict[a] > 1)
    duplicates(count(names)).forEach(res1 => {
      this.brokersColumns.map(res2 => {
        if (res1 === res2.standardCsvColumn) {
          res2.isDuplicate = true;
        }
      })
    })
  }

  setAll(completed: boolean) {
    this.csvFileData.forEach(t => t.status = completed);
    this.selectCheckBox();
    this.totalInvestMent();
  }

  submitCsvData() {
    if (this.addSingleTradeStatus === true) {
      this.csvFileData.forEach((element, index) => {
        if (index === this.addSingleTradeIndex) {
          if (element.status === true) {
            if (element.purchaseDate === null || element.purchaseDate === undefined || element.purchaseDate === '') {
              this.addSingleTradeStatus = false;
              return this.notifierService.notify('error', "Invalid date.");
            }
            if (element.currentPrice === null || element.currentPrice === undefined || element.currentPrice === '' || element.currentPrice < 0) {
              this.addSingleTradeStatus = false;
              return this.notifierService.notify('error', "Invalid price.");
            }
            if (element.quantity === null || element.quantity === undefined || element.quantity === '' || element.quantity < 0) {
              this.addSingleTradeStatus = false;
              return this.notifierService.notify('error', "Invalid quantity.");
            }
            if (element.tradeType === null || element.tradeType === undefined || element.tradeType === '') {
              this.addSingleTradeStatus = false;
              return this.notifierService.notify('error', "Invalid trade type.");
            }
            if (element.status === true) {
              if (element.invalidSymbol === true) {
                this.addSingleTradeStatus = false;
                return this.notifierService.notify('error', "Invalid symbol,exchange or purchase date.(" + element.symbol + ":" + element.exchange + ")");
              }
            }
            if (element.stockCurrency !== element.baseCurrency) {
              if (element.exchangeRate === null || element.exchangeRate === undefined || element.exchangeRate === '' || element.exchangeRate < 0) {
                this.addSingleTradeStatus = false;
                return this.notifierService.notify('error', "Invalid exchange rate.(" + element.symbol + ":" + element.exchange + ")");
              }
            }
            if (this.ls.get('portfolioRemainingCash') < element.totalPrice) {
              this.addSingleTradeStatus = false;
              return this.notifierService.notify('error', 'Not enough balance to purchase.');
            }
            this.addMultiplestocks(this.csvFileData);
          } else {
            return this.notifierService.notify('error', "Please select check box.");
          }
        }
      });
    } else {
      var count = 0;
      this.csvFileData.forEach((element) => {
        if (element.status === true) {
          if (element.purchaseDate === null || element.purchaseDate === undefined || element.purchaseDate === '') {
            return this.notifierService.notify('error', "Invalid date.");
          }
          if (element.currentPrice === null || element.currentPrice === undefined || element.currentPrice === '' || element.currentPrice < 0) {
            return this.notifierService.notify('error', "Invalid price.");
          }
          if (element.quantity === null || element.quantity === undefined || element.quantity === '' || element.quantity < 0) {
            return this.notifierService.notify('error', "Invalid quantity.");
          }
          if (element.tradeType === null || element.tradeType === undefined || element.tradeType === '') {
            return this.notifierService.notify('error', "Invalid trade type.");
          }
          if (element.status === true) {
            if (element.invalidSymbol === true) {
              return this.notifierService.notify('error', "Invalid symbol,exchange or purchase date.(" + element.symbol + ":" + element.exchange + ")");
            }
          }
          if (element.stockCurrency !== element.baseCurrency) {
            if (element.exchangeRate === null || element.exchangeRate === undefined || element.exchangeRate === '' || element.exchangeRate < 0) {
              return this.notifierService.notify('error', "Invalid exchange rate.(" + element.symbol + ":" + element.exchange + ")");
            }
          }
          count++;
        }
      });
      if (this.ls.get('portfolioRemainingCash') < this.totalPurchasingValue) {
        return this.notifierService.notify('error', 'Not enough balance to purchase.');
      }
      if (this.selectedCount === count) {
        this.addMultiplestocks(this.csvFileData);
      }
    }
  }
  selectCheckBox() {
    this.selectedCount = 0;
    this.disableButton = true;
    this.csvFileData.forEach((res) => {
      if (res.status === true) {
        this.selectedCount++;
        this.disableButton = false;
      }
    });
    this.totalInvestMent();
  }

  addMultiplestocks(fileData) {
    this.editIndex = '';
    this.count = 0;
    this.statusCount = 0
    this.stockTradearray = [];
    const filedataArray = fileData;
    if (this.addSingleTradeStatus === true) {
      filedataArray.forEach(async (res, reqIndex) => {
        if (reqIndex === this.addSingleTradeIndex) {
          if (res.status === true) {
            this.count++;
            const payloadForPortfolio = {
              portfolioId: this.ls.get('editPortfolioId'),
              stocks: [
                {
                  currentPrice: res.currentPrice,
                  exchange: res.exchange,
                  instrumentId: res.instrumentId,
                  isin: res.isin,
                  name: res.name,
                  priceLastUpdate: this.datePipe.transform(res.purchaseDate, 'yyyy-MM-dd'),
                  quantity: parseFloat(res.quantity),
                  quantityLastUpdate: this.datePipe.transform(res.purchaseDate, 'yyyy-MM-dd'),
                  sector: {
                    industryGroupId: "31020",
                    industryGroupName: "Business Services",
                    industryId: "31020040",
                    industryName: "null",
                    instrumentId: "US-15774",
                    sectorId: "310",
                    sectorName: "Industrials",
                    superSectorId: "3",
                    superSectorName: "Sensitive"
                  },
                  symbol: res.symbol,
                  currency: res.currency,
                  brokerageCurrency: res.currency,
                  exchangeRate: res.exchangeRate,
                }
              ]
            }
            await this.service.addStockToPortfolio(payloadForPortfolio, (resStockData) => {
              this.stockForTrade1 = JSON.parse(resStockData);
              this.stockTradearray.push({ stockResponse: this.stockForTrade1, index: reqIndex, fileData: res });
              if (this.count == this.stockTradearray.length) {
                this.stockTradearray.forEach(resData => {
                  var isOpeningBalance;
                  var brokerage = 0;
                  var tradeCurrency;
                  if (resData.fileData.tradeType === "OPENING_BALANCE") {
                    isOpeningBalance = true;
                    brokerage = resData.fileData.currentPrice
                    tradeCurrency = this.ls.get('investorDetails').userId.currency;
                  } else {
                    isOpeningBalance = false;
                    brokerage = resData.fileData.brokerage
                    tradeCurrency = resData.fileData.tradeCurrency;
                  }
                  resData.stockResponse[0].sector = {
                    industryGroupId: "31020",
                    industryGroupName: "Business Services",
                    industryId: "31020040",
                    industryName: "null",
                    instrumentId: "US-15774",
                    sectorId: "310",
                    sectorName: "Industrials",
                    superSectorId: "3",
                    superSectorName: "Sensitive"
                  };
                  const payload = {
                    brokerage: brokerage ? brokerage : 0,
                    comments: resData.fileData.comments,
                    instrumentId: resData.fileData.instrumentId,
                    investorId: this.ls.get('investorDetails').id,
                    isOpeningBalance: isOpeningBalance,
                    isin: resData.fileData.isin,
                    openingBalanceDate: this.datePipe.transform(resData.fileData.purchaseDate, 'yyyy-MM-dd'),
                    price: resData.fileData.currentPrice,
                    purchaseDate: this.datePipe.transform(resData.fileData.purchaseDate, 'yyyy-MM-dd'),
                    quantity: parseFloat(resData.fileData.quantity),
                    tradeDate: this.datePipe.transform(resData.fileData.purchaseDate, 'yyyy-MM-dd'),
                    tradeId: 0,
                    tradeType: resData.fileData.tradeType,
                    isAddHolding: true,
                    stock: resData.stockResponse[0],
                    baseCurrency: this.ls.get('investorDetails').userId.currency,
                    brokerageCurrency: resData.fileData.brokerageCurrency,
                    exchangeRate: resData.fileData.exchangeRate,
                    stockCurrency: resData.fileData.stockCurrency,
                    tradeCurrency: resData.fileData.stockCurrency,
                    brokerageCurrencyExchangeRate: resData.fileData.exchangeRate
                  }
                  this.service.saveTrade(payload).subscribe((resTrade) => {
                    if (resTrade.tradeType === "OPENING_BALANCE") {
                      this.ls.set("OpeninBalance", this.ls.get("OpeninBalance") + resTrade.quantity * resTrade.price);
                    }
                    this.notifierService.notify('success', "holding added successfully");
                    this.ls.set('portfolioRemainingCash', this.ls.get('portfolioRemainingCash') - parseFloat(res.totalPrice))
                    this.csvFileData.splice(this.addSingleTradeIndex, 1)
                    this.dataSource = new MatTableDataSource(this.csvFileData);
                    this.dataSource.sort = this.sort;
                    this.addSingleTradeStatus = false;
                    this.ls.set('csvFileData', this.csvFileData);
                    this.selectCheckBox();
                    if (this.ls.get('csvFileData').length === 0) {
                      this.router.navigate([])
                      this.router.navigate(['/user/portfolio-details'], { queryParams: { editPortfolioId: this.ls.get('editPortfolioId'), from: 'uploadCsv' } });
                    }
                  }, error => {
                    this.service.errorFunction(error);
                  });
                })
              }
            }, (error) => {
              this.service.errorFunction(error);
            });
          }
        }
      });
    } else {
      this.selectedTrades = [];
      this.globalIndex = 0;
      filedataArray.forEach(element => {
        if (element.status === true) {
          this.selectedTrades.push(element)
        }
      });
      this.count = this.selectedTrades.length;
      this.arraindex = [];
      this.failedArray = [];
      this.addstocksRecursiveMethod()
    }
  }

  addstocksRecursiveMethod() {
    var res;
    res = this.selectedTrades[this.globalIndex];
    if (res.status === true) {
      const payloadForPortfolio = {
        portfolioId: this.ls.get('editPortfolioId'),
        stocks: [
          {
            currentPrice: res.currentPrice,
            exchange: res.exchange,
            instrumentId: res.instrumentId,
            isin: res.isin,
            name: res.name,
            priceLastUpdate: this.datePipe.transform(res.purchaseDate, 'yyyy-MM-dd'),
            quantity: parseFloat(res.quantity),
            quantityLastUpdate: this.datePipe.transform(res.purchaseDate, 'yyyy-MM-dd'),
            sector: {
              industryGroupId: "31020",
              industryGroupName: "Business Services",
              industryId: "31020040",
              industryName: "null",
              instrumentId: "US-15774",
              sectorId: "310",
              sectorName: "Industrials",
              superSectorId: "3",
              superSectorName: "Sensitive"
            },
            symbol: res.symbol,
            currency: res.currency,
            brokerageCurrency: res.currency,
            exchangeRate: res.exchangeRate,
          }
        ]
      }
      this.service.addStockToPortfolio(payloadForPortfolio, (resStockData) => {
        this.stockForTrade1 = JSON.parse(resStockData);
        this.stockTradearray.push({ stockResponse: this.stockForTrade1, fileData: res });
        var isOpeningBalance;
        var brokerage = 0;
        if (res.tradeType === "OPENING_BALANCE") {
          isOpeningBalance = true;
          brokerage = res.currentPrice
        } else {
          isOpeningBalance = false;
          brokerage = res.brokerage
        }
        this.stockForTrade1[0].sector = {
          industryGroupId: "31020",
          industryGroupName: "Business Services",
          industryId: "31020040",
          industryName: "null",
          instrumentId: "US-15774",
          sectorId: "310",
          sectorName: "Industrials",
          superSectorId: "3",
          superSectorName: "Sensitive"
        };
        const payload = {
          brokerage: brokerage ? brokerage : 0,
          comments: res.comments,
          instrumentId: res.instrumentId,
          investorId: this.ls.get('investorDetails').id,
          isOpeningBalance: isOpeningBalance,
          isin: res.isin,
          openingBalanceDate: this.datePipe.transform(res.purchaseDate, 'yyyy-MM-dd'),
          price: res.currentPrice,
          purchaseDate: this.datePipe.transform(res.purchaseDate, 'yyyy-MM-dd'),
          quantity: parseFloat(res.quantity),
          tradeDate: this.datePipe.transform(res.purchaseDate, 'yyyy-MM-dd'),
          tradeId: 0,
          tradeType: res.tradeType,
          isAddHolding: true,
          stock: this.stockForTrade1[0],
          baseCurrency: this.ls.get('investorDetails').userId.currency,
          brokerageCurrency: res.brokerageCurrency,
          exchangeRate: res.exchangeRate,
          stockCurrency: res.stockCurrency,
          tradeCurrency: res.stockCurrency,
          brokerageCurrencyExchangeRate: res.exchangeRate
        }
        this.service.saveTrade(payload).subscribe((resTrade) => {
          this.globalIndex++;
          if (this.globalIndex !== this.selectedTrades.length) {
            this.addstocksRecursiveMethod();
          }
          this.count--;
          if (resTrade.tradeType === "OPENING_BALANCE") {
            this.ls.set("OpeninBalance", this.ls.get("OpeninBalance") + resTrade.quantity * resTrade.price);
          }
          this.arraindex.push(resTrade);
          const csvData = this.csvFileData;
          if (this.count === 0) {
            this.notifierService.notify('success', "" + this.arraindex.length + " holdings added successfully");
            this.ls.set('portfolioRemainingCash', this.ls.get('portfolioRemainingCash') - this.totalPurchasingValue)
            this.stockTradearray.forEach(res1 => {
              const index = this.arraindex.findIndex(res2 => res2.stock.name == res1.fileData.name);
              if (index === -1) {
                this.failedArray.push(res1);
              }
              this.arraindex.forEach(resArray => {
                const index1 = csvData.findIndex(res3 => res3.name == resArray.stock.name);
                if (index1 !== -1) {
                  this.csvFileData.splice(index1, 1);
                }
                this.dataSource = new MatTableDataSource(this.csvFileData);
                this.dataSource.sort = this.sort;
                this.ls.set('csvFileData', this.csvFileData);
              })
            })
            if (this.failedArray.length > 0) {
              this.failedArray.forEach(res3 => {
                this.notifierService.notify('error', "Failed to add " + res3.fileData.name + " holdings.");
              })
            }
            if (this.ls.get('csvFileData').length === 0) {
              this.router.navigate([])
              this.router.navigate(['/user/portfolio-details'], { queryParams: { editPortfolioId: this.ls.get('editPortfolioId'), from: 'uploadCsv' } });
            }
            this.selectCheckBox();
          }
        }, error => {
          this.count--;
          this.service.errorFunction(error);
        });
      }, (error) => {
        this.service.errorFunction(error);
      });
    }
  }

  renameKeys(obj, newKeys) {
    const keyValues = Object.keys(obj).map(key => {
      const newKey = newKeys[key] || key;
      return { [newKey]: obj[key] };
    });
    return Object.assign({}, ...keyValues);
  }


  totalInvestMent() {
    var exchangePrice;
    this.totalPurchasingValue = 0;
    var buyTotal = 0;
    var sellTotal = 0;
    var tradebrok;
    this.csvFileData.map(element => {
      if (element.status === true) {
        if (element.invalidSymbol === false && element.exchangeSymbol === false) {
          if (element.tradeType === "BUY") {
            if (this.ls.get('investorDetails').userId.currency == element.stockCurrency) {
              if (element.brokerage == null || element.brokerage == '' || element.brokerage == undefined) {
                tradebrok = 0;
              } else {
                tradebrok = element.brokerage;
              }
              buyTotal += parseFloat(element.currentPrice) * parseInt(element.quantity) + parseFloat(tradebrok);
              element.totalPrice = parseFloat(element.currentPrice) * parseInt(element.quantity) + parseFloat(tradebrok);
              this.totalPurchasingValue = buyTotal - sellTotal;
            } else {
              if (this.ls.get('investorDetails').userId.currency == element.tradeCurrency) {
                exchangePrice = parseFloat(element.exchangeRate);
              } else {
                exchangePrice = 1 / parseFloat(element.exchangeRate);
              }
              if (element.brokerage == null || element.brokerage == '' || element.brokerage == undefined) {
                tradebrok = 0;
              } else {
                if (this.ls.get('investorDetails').userId.currency == element.brokerageCurrency) {
                  tradebrok = element.brokerage;
                } else {
                  if (this.ls.get('investorDetails').userId.currency == element.tradeCurrency) {
                    tradebrok = element.brokerage * parseFloat(element.exchangeRate);
                  } else {
                    var convertData = 1 / parseFloat(element.exchangeRate);
                    tradebrok = element.brokerage * convertData;
                  }
                }
              }
              buyTotal += parseFloat(element.currentPrice) * parseInt(element.quantity) * parseFloat(exchangePrice) + parseFloat(tradebrok);
              element.totalPrice = parseFloat(element.currentPrice) * parseInt(element.quantity) * parseFloat(exchangePrice) + parseFloat(tradebrok);
              this.totalPurchasingValue = buyTotal - sellTotal;
            }
          } else if (element.tradeType === "SELL") {
            if (this.ls.get('investorDetails').userId.currency == element.stockCurrency) {
              if (element.brokerage == null || element.brokerage == '' || element.brokerage == undefined) {
                tradebrok = 0;
              } else {
                tradebrok = element.brokerage;
              }
              sellTotal += parseFloat(element.currentPrice) * parseInt(element.quantity);
              element.totalPrice = parseFloat(element.currentPrice) * parseInt(element.quantity);
              this.totalPurchasingValue = buyTotal - sellTotal;
            } else {
              if (this.ls.get('investorDetails').userId.currency == element.tradeCurrency) {
                exchangePrice = parseFloat(element.exchangeRate);
              } else {
                exchangePrice = 1 / parseFloat(element.exchangeRate);
              }
              if (element.brokerage == null || element.brokerage == '' || element.brokerage == undefined) {
                tradebrok = 0;
              } else {
                if (this.ls.get('investorDetails').userId.currency == element.brokerageCurrency) {
                  tradebrok = element.brokerage;
                } else {
                  if (this.ls.get('investorDetails').userId.currency == element.tradeCurrency) {
                    tradebrok = element.brokerage * parseFloat(element.exchangeRate);
                  } else {
                    var convertData = 1 / parseFloat(element.exchangeRate);
                    tradebrok = element.brokerage * convertData;
                  }
                }
              }
              sellTotal += parseFloat(element.currentPrice) * parseInt(element.quantity) * parseFloat(exchangePrice);
              element.totalPrice = parseFloat(element.currentPrice) * parseInt(element.quantity) * parseFloat(exchangePrice);
              this.totalPurchasingValue = buyTotal - sellTotal;
            }
          }
        }
      }
    });
  }

  deleteCsvData() {
    var filterArray = [];
    this.csvFileData.forEach((element) => {
      if (element.status !== true) {
        filterArray.push(element);
      }
    })
    this.dataSource = new MatTableDataSource(filterArray);
    this.dataSource.sort = this.sort;
    this.csvFileData = filterArray;
    this.selectedCount = 0;
    this.ls.set('csvFileData', this.csvFileData);
  }

  editTrade(i, data) {
    this.getRegisterdStocks('keyup');
    this.editIndex = i;
    this.importCsv.patchValue({
      name: data.name,
      symbol: data.symbol,
      exchange: data.exchange,
      brokerage: data.brokerage,
      purchaseDate: this.datePipe.transform(data.purchaseDate, 'mediumDate'),
      tradeType: data.tradeType,
      quantity: data.quantity,
      currentPrice: data.currentPrice,
      exchangeRate: data.exchangeRate,
      tradeCurrency: data.tradeCurrency,
      brokerageCurrency: data.brokerageCurrency,
      holdingName: data.symbol + ":" + data.exchange
    })
    this.editTradeData = data;
    this.stockCurrency = this.ls.get('investorDetails').userId.currency;
    this.symbolAndExchange = data;
    this.getParticularExchangerate(data);
  }

  updateTrade(i) {
    if (this.importCsv.valid) {
      if (this.showPrice === true) {
        return this.notifierService.notify('error', 'Price is not available on this date.');
      }
      if (this.showExchangeRate === true) {
        return this.notifierService.notify('error', 'Exchange rate is not available to this date.');
      }
      this.csvFileData.map((res, index) => {
        if (i === index) {
          res.name = this.stockDetails.instrument.name,
            res.symbol = this.stockDetails.instrument.symbol,
            res.exchange = this.stockDetails.instrument.exchangeSymbol,
            res.brokerage = this.importCsv.value.brokerage,
            res.purchaseDate = this.importCsv.value.purchaseDate,
            res.tradeType = this.importCsv.value.tradeType,
            res.quantity = this.importCsv.value.quantity,
            res.currentPrice = this.importCsv.value.currentPrice,
            res.exchangeRate = this.importCsv.value.exchangeRate,
            res.tradeCurrency = this.importCsv.value.tradeCurrency,
            res.brokerageCurrency = this.importCsv.value.brokerageCurrency,
            res.isin = this.stockDetails.instrument.isin;
          res.instrumentId = this.stockDetails.instrument.id;
          res.baseCurrency = this.ls.get('investorDetails').userId.currency;
          res.stockCurrency = this.stockDetails.instrument.currency;
          res.importstatus = false;
          res.invalidSymbol = false;
          res.exchangeSymbol = false;
          res.currency = this.stockDetails.instrument.currency;
          res.holdingName = this.stockDetails.instrument.symbol + ":" + this.stockDetails.instrument.exchangeSymbol;
        }
      })
      this.ls.set('csvFileData', this.csvFileData);
      this.dataSource = new MatTableDataSource(this.csvFileData);
      this.dataSource.sort = this.sort;
      this.editIndex = '';
      this.totalInvestMent();
    } else {
      this.formSumitAttempt = true;
      this.notifierService.notify('error', 'Invalid Inputs');
    }
  }

  getexchangeDetails() {
    this.countStock = 0;
    this.selectedCount = 0;
    var status;
    var importstatus;
    var purchaseDate;
    this.csvFileData.map(async (value) => {
      value.currentPrice = value.purchasePrice
      this.countStock++;
      try {
        purchaseDate = this.datePipe.transform(value.purchaseDate, 'yyyy-MM-dd')
      } catch (e) {
        this.countStock--;
        value.status = false;
        value.invalidSymbol = true;
        value.holdingName = value.symbol + ":" + value.exchange;
        value.purchaseDate = value.purchaseDate;
        value.errorMessage = 'Invalid trade date format';
      }
      const query = {
        symbolAndExchange: (value.symbol + ":" + value.exchange).trim(),
        date: purchaseDate
      }
      await this.service.getStockDetailByUsingSymbol(query).subscribe(async data => {
        const res = JSON.parse(data)
        if (res.errorCode) {
          this.countStock--;
          value.status = false;
          value.invalidSymbol = true;
          value.holdingName = value.symbol + ":" + value.exchange;
          value.errorMessage = res.message;
          if (this.countStock === 0) {
            this.ls.set('csvFileData', this.csvFileData);
            this.copyCsvData = this.csvFileData;
            this.dataSource = new MatTableDataSource(this.csvFileData);
            this.dataSource.sort = this.sort;
            this.totalInvestMent()
          }
          return;
        }
        this.countStock--;
        value.exchangeSymbol = false;
        if (value.status === true) {
          status = true
          this.selectedCount++;
          this.disableButton = false;
        } else {
          status = false
        }
        if (value.importstatus === true) {
          importstatus = true
        } else {
          importstatus = false
        }
        if (this.ls.get('investorDetails').userId.currency !== res.instrument.currency) {
          const query1 = {
            exchangeRateDate: this.datePipe.transform(res.priceLastUpdate, 'yyyy-MM-dd'),
            convertToCurrencyCode: res.instrument.currency,
            convertFromCurrencyCode: this.ls.get('investorDetails').userId.currency
          }
          await this.service.getExchangeRateConvert(query1).subscribe(resExchange => {
            if (value.symbol === res.instrument.symbol && value.exchange === res.instrument.exchangeSymbol) {
              if (resExchange > 0) {
                if (parseFloat(value.exchangeRate) > 0) {
                  value.exchangeRate = value.exchangeRate;
                  value.exchangeSymbol = false;
                } else {
                  value.exchangeRate = resExchange;
                  value.exchangeSymbol = false;
                  value.errorMessage = 'Exchange rate is not available to this date.'
                }
              } else {
                value.exchangeRate = null;
                value.exchangeSymbol = true;
                value.errorMessage = 'Exchange rate is not available to this date.'
              }
            }
          }, (error) => {
            this.service.errorFunction(error);
          })
        }
        if (value.symbol === res.instrument.symbol && value.exchange === res.instrument.exchangeSymbol) {
          value.isin = res.instrument.isin;
          value.instrumentId = res.instrument.id;
          value.baseCurrency = this.ls.get('investorDetails').userId.currency;
          value.brokerageCurrency = res.instrument.currency;
          value.stockCurrency = res.instrument.currency;
          value.tradeCurrency = res.instrument.currency;
          value.holdingName = value.symbol + ":" + value.exchange;
          value.status = status;
          value.currency = res.instrument.currency;
          value.importstatus = importstatus;
          value.invalidSymbol = false;
          value.name = res.instrument.name
        }
        if (this.countStock === 0) {
          this.ls.set('csvFileData', this.csvFileData);
          this.copyCsvData = this.csvFileData;
          this.dataSource = new MatTableDataSource(this.csvFileData);
          this.dataSource.sort = this.sort;
          this.totalInvestMent()
        }
      }, () => {
        this.countStock--;
        value.status = false;
        value.invalidSymbol = true;
        value.holdingName = value.symbol + ":" + value.exchange;
        value.errorMessage = 'Invalid symbol,exchange or purchase date.';
        if (this.countStock === 0) {
          this.ls.set('csvFileData', this.csvFileData);
          this.copyCsvData = this.csvFileData;
          this.dataSource = new MatTableDataSource(this.csvFileData);
          this.dataSource.sort = this.sort;
          this.totalInvestMent()
        }
      });
    });
  }
  selectedTradeDate(value) {
    this.importCsv.patchValue({ purchaseDate: this.datePipe.transform(value, 'mediumDate') })
    this.getParticularExchangerate(this.symbolAndExchange);
  }

  private _filterStates(value): Stocks[] {
    const filterValue = value.holdingName.toLowerCase();
    return this.stocksDetails.filter(state => state.name.toLowerCase().includes(filterValue) || state.exchange.toLowerCase().includes(filterValue) || state.symbol.toLowerCase().includes(filterValue));
  }

  showBrokersList() {
    var duplicateArray = [];
    this.brokersColumns.map(res => {
      if (res.standardCsvColumn !== 'none') {
        duplicateArray.push(res.standardCsvColumn)
      }
    })
    for (let i = 0; i < duplicateArray.length; i++) {
      if (duplicateArray.indexOf(duplicateArray[i]) !== duplicateArray.lastIndexOf(duplicateArray[i])) {
        const data = {
          text: 'Broker CSV columns should be unique.',
          type: 'warning'
        }
        return this.service.openSweetAlert(data);
      }
    }
    this.showMore = !this.showMore;

    var convertObjArr = Object.keys(this.ls.get('csvFileData')[0])
    var columnMap = [];
    convertObjArr.map(res => {
      this.brokersColumns.forEach(res2 => {
        if (res === res2.brokerCsvColumn) {
          columnMap.push({ [res]: res2.standardCsvColumn });
        }
      })
    })
    var mappedArray = [];
    this.ls.get('csvFileData').forEach((element, i) => {
      const renamedObj = this.renameKeys(element, Object.assign({}, ...columnMap));
      mappedArray.push(renamedObj)
      this.ls.set('csvFileData', mappedArray);
      if (i + 1 === this.ls.get('csvFileData').length) {
        this.csvFileData = mappedArray;
        this.router.navigate(['/user/import-csv']);
      }
    });
  }

  selectExchange(value) {
    this.importCsv.patchValue({ holdingName: value.symbol + ":" + value.exchange });
    this.symbolAndExchange = value;
    this.getParticularExchangerate(value);
  }

  getRegisterdStocks(data) {
    if (data === "keyup") {
      this.stocksDetails = [];
      this.registerStocks = [];
      if (this.isAutocomplete1 === true) {
        this.statesAutocompleteRef1.panel.nativeElement
          .scrollTop = 0
      }
      this.count1 = 0;
    }
    const payload = {
      "searchString": this.importCsv.value.holdingName.trim(''),
      "index": this.count1,
      "size": 100
    }
    this.showExchangeListSpinner1 = true;
    this.service.isShowSpinner = false;
    this.service.getAllRegisterdStocks(payload).subscribe(res => {
      this.registerStocks = res;
      this.showExchangeListSpinner1 = false;
      this.service.isShowSpinner = false;
      res.forEach((element, i) => {
        this.stocksDetails.push(element);
      });
      this.filteredStocks = this.importCsv.valueChanges
        .pipe(
          startWith(''),
          map(stocks => stocks ? this.stocksDetails.slice() : this.stocksDetails.slice())
        );
    }, (error) => {
      this.showExchangeListSpinner1 = false;
      this.service.isShowSpinner = false;
      this.service.errorFunction(error);
    })
  }

  addTrade(value) {
    this.addSingleTradeStatus = true;
    this.addSingleTradeIndex = value;
    this.submitCsvData();
  }

  getParticularExchangerate(value) {
    const query = {
      symbolAndExchange: (this.importCsv.value.holdingName).trim(),
      date: this.datePipe.transform(this.importCsv.value.purchaseDate, 'yyyy-MM-dd')
    }
    this.service.getStockDetailByUsingSymbol(query).subscribe(data => {
      this.stockDetails = JSON.parse(data)
      if (this.stockDetails.errorCode) {
        if (this.datePipe.transform(this.importCsv.value.purchaseDate, 'yyyy-MM-dd') !== this.datePipe.transform(this.editTradeData.purchaseDate, 'yyyy-MM-dd')) {
          return this.notifierService.notify('error', this.stockDetails.message);
        }
      }
      if (this.stockDetails.unAdjPrice) {
        this.importCsv.patchValue({
          currentPrice: this.stockDetails.unAdjPrice
        })
      } else {
        this.importCsv.patchValue({
          currentPrice: this.stockDetails.price
        })
      }
      this.showPrice = false;
      this.stockCurrency = this.stockDetails.instrument.currency;
      if (this.editTradeData.baseCurrency !== this.stockDetails.instrument.currency) {
        this.getExchangeRate();
      } else {
        this.showExchangeRate = false;
      }
      this.patchData();
      this.showCurrentPrice();
    }, () => {
      this.showPrice = true;
      this.notifierService.notify('error', 'Invalid symbol,exchange or purchase date.');
    })
  }

  clickCurrentPrice() {
    if (this.stockDetails.unAdjPrice) {
      this.importCsv.patchValue({
        currentPrice: this.stockDetails.unAdjPrice,
      })
    } else {
      this.importCsv.patchValue({
        currentPrice: this.stockDetails.price,
      })
    }
    this.showCurrentPrice();
  }

  getExchangeRate() {
    if (this.ls.get('investorDetails').userId.currency !== this.editTradeData.currency) {
      var query;
      if (this.ls.get('investorDetails').userId.currency == this.importCsv.value.tradeCurrency) {
        query = {
          exchangeRateDate: this.datePipe.transform(this.importCsv.value.purchaseDate, 'yyyy-MM-dd'),
          convertToCurrencyCode: this.ls.get('investorDetails').userId.currency,
          convertFromCurrencyCode: this.stockDetails.instrument.currency
        }
      } else {
        query = {
          exchangeRateDate: this.datePipe.transform(this.importCsv.value.purchaseDate, 'yyyy-MM-dd'),
          convertToCurrencyCode: this.stockDetails.instrument.currency,
          convertFromCurrencyCode: this.ls.get('investorDetails').userId.currency
        }
      }
      this.service.getExchangeRateConvert(query).subscribe(res => {
        this.exchangePrice = JSON.parse(res);
        if (this.importCsv.value.brokerageCurrency === null || this.importCsv.value.brokerageCurrency === undefined || this.importCsv.value.brokerageCurrency === '') {
          this.importCsv.patchValue({ brokerageCurrency: this.stockDetails.instrument.currency })
        }
        if (this.importCsv.value.tradeCurrency === null || this.importCsv.value.tradeCurrency === undefined || this.importCsv.value.tradeCurrency === '') {
          this.importCsv.patchValue({ tradeCurrency: this.stockDetails.instrument.currency, exchangeRate: this.exchangePrice })
        }
        if (this.exchangePrice > 0) {
          this.showExchangeRate = false;
        } else {
          this.notifierService.notify('error', 'Exchange rate is not available to this date.');
          this.showExchangeRate = true;
        }
        this.showExchangePrice();
      }, (error) => {
        this.service.errorFunction(error);
        this.showExchangeRate = true;
      })
    }
  }

  selectExchangeRate() {
    this.importCsv.patchValue({ exchangeRate: this.exchangePrice });
    this.showExchangePrice();
  }

  showExchangePrice() {
    if (this.exchangePrice === parseFloat(this.importCsv.value.exchangeRate)) {
      this.showexchangeLabel = false;
    } else {
      this.showexchangeLabel = true;
    }
  }

  showCurrentPrice() {
    if (this.stockDetails.unAdjPrice) {
      if (this.stockDetails.unAdjPrice === parseFloat(this.importCsv.value.currentPrice)) {
        this.showCurrentLabel = false;
      } else {
        this.showCurrentLabel = true;
      }
    } else {
      if (this.stockDetails.price === parseFloat(this.importCsv.value.currentPrice)) {
        this.showCurrentLabel = false;
      } else {
        this.showCurrentLabel = true;
      }
    }
  }

  patchData() {
    if (this.ls.get('investorDetails').userId.currency !== this.stockDetails.instrument.currency) {
      this.importCsv.controls["exchangeRate"].setValidators([Validators.required, Validators.min(0.0001)]);
      this.importCsv.controls["exchangeRate"].updateValueAndValidity();
    } else {
      this.importCsv.controls["exchangeRate"].setValidators(null);
      this.importCsv.controls["exchangeRate"].updateValueAndValidity();
    }
  }

  isFieldValid(field: string) {
    return (
      (!this.importCsv.get(field).valid && this.importCsv.get(field).touched) ||
      (this.importCsv.get(field).untouched && this.formSumitAttempt)
    );
  }

  removeTrade(i) {
    this.csvFileData.splice(i, 1)
    this.dataSource = new MatTableDataSource(this.csvFileData);
    this.dataSource.sort = this.sort;
    this.ls.set('csvFileData', this.csvFileData);
  }


  autocompleteScroll1() {
    setTimeout(() => {
      if (
        this.statesAutocompleteRef1 &&
        this.autocompleteTrigger1 &&
        this.statesAutocompleteRef1.panel
      ) {
        fromEvent(this.statesAutocompleteRef1.panel.nativeElement, 'scroll')
          .pipe(
            map(x => this.statesAutocompleteRef1.panel.nativeElement.scrollTop),
            takeUntil(this.autocompleteTrigger1.panelClosingActions)
          )
          .subscribe(x => {
            const scrollTop = this.statesAutocompleteRef1.panel.nativeElement
              .scrollTop;
            const scrollHeight = this.statesAutocompleteRef1.panel.nativeElement
              .scrollHeight;
            const elementHeight = this.statesAutocompleteRef1.panel.nativeElement
              .clientHeight;
            const atBottom = scrollHeight === scrollTop + elementHeight;
            this.isAutocomplete1 = true;
            if (atBottom) {
              this.count1++;
              if (this.registerStocks.length === 100) {
                this.getRegisterdStocks('scroll')
              }
            }
          });
      }
    });
  }

  changeBrokerCsv(value, index) {
    this.brokersColumns.map((res, i) => {
      if (i === index) {
        res.standardCsvColumn = value;
      }
    })
    this.findDuplicateBrokerCsvColumns();
  }
}
export interface Stocks {
  name: string;
  symbol: string;
  exchange: string;
}


